/* First Pace — signature interactions: insole finder + interactive anatomy */
(function () {
  'use strict';

  /* ---------- insole finder ---------- */
  function initFinder(root) {
    (root || document).querySelectorAll('[data-fp-finder]:not([data-ready])').forEach(function (f) {
      f.setAttribute('data-ready', '');
      var steps = f.querySelectorAll('[data-step]');
      var dots = f.querySelectorAll('[data-step-dot]');

      function go(n) {
        steps.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') === String(n)); });
        dots.forEach(function (d) { d.classList.toggle('is-on', Number(d.getAttribute('data-step-dot')) <= n); });
      }

      function currentAnswers() {
        return Array.prototype.map.call(f.querySelectorAll('[data-step] input[type="radio"]:checked'), function (i) { return i.value; });
      }

      function showResult() {
        var result = currentAnswers().indexOf('heat') !== -1 ? 'heat' : 'arch';
        var cards = f.querySelectorAll('[data-result]');
        var shown = false;
        cards.forEach(function (c) {
          var match = c.getAttribute('data-result') === result;
          c.hidden = !match;
          c.style.display = match ? '' : 'none';
          if (match) shown = true;
        });
        if (!shown && cards[0]) { cards[0].hidden = false; cards[0].style.display = ''; }
        go(3);
      }

      f.querySelectorAll('[data-step="1"] input').forEach(function (i) {
        i.addEventListener('change', function () { setTimeout(function () { go(2); }, 220); });
      });
      f.querySelectorAll('[data-step="2"] input').forEach(function (i) {
        i.addEventListener('change', function () { setTimeout(showResult, 220); });
      });
      var back = f.querySelector('[data-fp-back]');
      if (back) back.addEventListener('click', function () { go(1); });
      f.querySelectorAll('[data-fp-restart]').forEach(function (r) {
        r.addEventListener('click', function () {
          f.querySelectorAll('input[type="radio"]').forEach(function (i) { i.checked = false; });
          go(1);
        });
      });
      // make sure no result card shows before the questions are answered
      f.querySelectorAll('[data-result]').forEach(function (c) { c.hidden = true; c.style.display = 'none'; });
    });
  }

  /* ---------- interactive anatomy ---------- */
  function initAnatomy(root) {
    (root || document).querySelectorAll('[data-fp-anatomy]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var pins = sec.querySelectorAll('.fp-pin');
      var items = sec.querySelectorAll('.fp-anat__item');
      var userTouched = false;

      function activate(n) {
        pins.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-part') === String(n)); });
        items.forEach(function (i) { i.classList.toggle('is-active', i.getAttribute('data-part') === String(n)); });
      }
      function touch(n) { userTouched = true; activate(n); }
      pins.forEach(function (p) {
        p.addEventListener('click', function () { touch(p.getAttribute('data-part')); });
        p.addEventListener('mouseenter', function () { touch(p.getAttribute('data-part')); });
      });
      items.forEach(function (i) {
        ['mouseenter', 'focus', 'click'].forEach(function (ev) {
          i.addEventListener(ev, function () { touch(i.getAttribute('data-part')); });
        });
      });

      if (pins.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        var n = 1, timer = null;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !timer && !userTouched) {
              timer = setInterval(function () {
                if (userTouched) { clearInterval(timer); timer = null; return; }
                n = n % pins.length + 1;
                activate(n);
              }, 2600);
            } else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.35 });
        io.observe(sec);
      }
    });
  }

  function init(root) { initFinder(root); initAnatomy(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();